import(/* webpackMode: "eager" */ "/app/src/app/[locale]/ui-ux/page.tsx");
